
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2OtFZ", function(module, exports) {
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $78z3f = parcelRequire("78z3f");


var $iA4lt = parcelRequire("iA4lt");


var $6Gsan = parcelRequire("6Gsan");


var $9d9t8 = parcelRequire("9d9t8");

const $d1337898ab272d64$export$de65f9bad07950f2 = ()=>{
    (0, $c6GJD.default).manuallyLogExperimentExposure('enable_google_drive_impersonation_search_in_fps');
};
const $d1337898ab272d64$export$6c232948b0f89805 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('enable_google_drive_impersonation_search_in_fps', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$43910e1172480373 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('kd_convo_starters_same_line', 'cohort', 'control') === 'test';
};
const $d1337898ab272d64$export$9f3b4e44245ab299 = (thirdPartyConfigs, isAllProductSearch)=>{
    const isSlackAuthenticated = !thirdPartyConfigs?.[(0, $78z3f.ProductKeys3P).Slack]?.userNeedsOAuth;
    const hasFederatedConnectorSource = thirdPartyConfigs?.[(0, $78z3f.ProductKeys3P).Slack]?.connectorSources?.includes((0, $9d9t8.FEDERATED_CONNECTOR_SOURCE));
    const isUserEligible = isSlackAuthenticated && hasFederatedConnectorSource && isAllProductSearch;
    return isUserEligible;
};
const $d1337898ab272d64$export$b8eda33c6a73a867 = (fireExperimentExposure = false)=>{
    return (0, $c6GJD.default).getExperimentValue('rovosearch_noun_result_counts', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$6cc04d45455a2e52 = (fireExperimentExposure = false)=>{
    return (0, $c6GJD.default).getExperimentValue('web_pages_type_filter_bug', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$1b405ed1dcef1833 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('qf_jira_recents_exclude_confluence', 'cohort', 'control', {
        fireExperimentExposure: false
    }) === 'test';
};
const $d1337898ab272d64$export$dbfae5c8d94a4c99 = (primaryProduct, { fireLayerExposure: fireLayerExposure = true } = {})=>{
    if (primaryProduct !== (0, $6Gsan.PrimaryProductKeys).Jira) return false;
    const layer = (0, $iA4lt.getMutuallyExclusiveUIExperiment)('rovo_qf_filter_suggestion_exp', 'rovo_search_qf_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    return layer?.get('isFilterSuggestionEnabled', false, (value)=>typeof value === 'boolean') ?? false;
};
const $d1337898ab272d64$export$df1791a16917f9c3 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('search_user_right_rail_3p_personalization_v1', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
const $d1337898ab272d64$export$a254d1715475fc25 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control') !== 'control';
};
const $d1337898ab272d64$export$6308fede6bfa9216 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control', {
        fireExperimentExposure: false
    }) !== 'control';
};
const $d1337898ab272d64$export$a28677150905172f = ()=>{
    return (0, $c6GJD.default).getExperimentValue('confluence_space_icon_update', 'isEnabled', false) === true;
};
const $d1337898ab272d64$export$f980294cad954499 = (thirdPartyConfigs, options = {
    fireExperimentExposure: true
})=>{
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    return isEligible3PUser && (0, $c6GJD.default).getExperimentValue('3p_clicks_in_fps_as_qf_recents', 'cohort', 'control', options) === 'test';
};
const $d1337898ab272d64$export$32815557e5d06f0a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_3p_boosting_experiment', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$752769d90d201b0a = ()=>{
    return (0, $c6GJD.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
const $d1337898ab272d64$export$9e14285db0210414 = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['multi_site_search_in_rovo']?.cohort;
    return cohort === 'test';
};
const $d1337898ab272d64$export$45bf6049ec3ec516 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('unified_search_one_click_3p_connect', 'isEnabled', false) === true;
};
/**
 * Unified Search 3P Connect Improvements Experiment
 */ const $d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS = [
    'icon-and-tooltip',
    'icon-only',
    'tooltip-only'
];
const $d1337898ab272d64$export$1abc158ee6a5b777 = [
    'control',
    ...$d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS
];
const $d1337898ab272d64$export$28f6b85de12145ce = ()=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('unified_search_3p_connect_improvements', 'cohort', 'control');
    if ($d1337898ab272d64$export$1abc158ee6a5b777.includes(cohort)) return cohort;
    return 'control';
};
const $d1337898ab272d64$export$f22ea87ae194d314 = ()=>{
    const cohort = $d1337898ab272d64$export$28f6b85de12145ce();
    return $d1337898ab272d64$var$UNIFIED_SEARCH_3P_CONNECT_IMPROVEMENTS_TEST_COHORTS.includes(cohort);
};
const $d1337898ab272d64$var$IMPROVE_BANNER_TARGETING_COHORTS = [
    'control',
    'usage-threshold',
    'max-dismissals'
];
const $d1337898ab272d64$export$647c2f5a2b1ce3a5 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('rovo_search_improve_banner_targeting', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$IMPROVE_BANNER_TARGETING_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $d1337898ab272d64$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS = [
    'control',
    'static',
    'dynamic'
];
const $d1337898ab272d64$export$1a051b8e8c16594f = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const treatment = (0, $c6GJD.default).getExperimentValue('inline_3p_query_suggestions_phase_1', 'inline_3p_query_suggestions_treatment', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$INLINE_3P_QUERY_SUGGESTIONS_TREATMENTS.includes(treatment)) return treatment;
    return 'control';
};
/**
 * Shared eligibility check for the FPS GitHub auth banner surfaces
 * (currently the `fps_github_social_proof_banner` experiment and the
 * `fps_github_auth_banner_promo` feature gate).
 *
 * A user is eligible when, on the GitHub 3P config:
 *  1. The GitHub connector is enabled in the tenant.
 *  2. The user has not yet connected to GitHub.
 *
 * This helper does NOT fire any Statsig exposure — it is a pure eligibility
 * gate intended to be evaluated BEFORE consulting an experiment value or
 * feature gate, so that ineligible users never enter the Statsig flow.
 */ const $d1337898ab272d64$var$isEligibleForFPSGitHubAuthBannerSurfaces = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    const githubConfig = thirdPartyConfigs?.[(0, $78z3f.ProductKeys3P).Github];
    if (!githubConfig) return false;
    // 1. GitHub connector enabled in tenant.
    if (typeof githubConfig.isEnabled === 'function' && !githubConfig.isEnabled()) return false;
    // 2. User is not yet connected to GitHub.
    if (githubConfig.userNeedsOAuth !== true) return false;
    return true;
};
const $d1337898ab272d64$export$d776328c2da05809 = ({ thirdPartyConfigs: thirdPartyConfigs }, options = {
    fireExperimentExposure: false
})=>{
    if (!$d1337898ab272d64$var$isEligibleForFPSGitHubAuthBannerSurfaces({
        thirdPartyConfigs: thirdPartyConfigs
    })) return false;
    return (0, $c6GJD.default).getExperimentValue('fps_github_social_proof_banner', 'cohort', 'control', options) === 'test';
};
const $d1337898ab272d64$export$380be6dfb8653da1 = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    if (!$d1337898ab272d64$var$isEligibleForFPSGitHubAuthBannerSurfaces({
        thirdPartyConfigs: thirdPartyConfigs
    })) return false;
    return (0, $dh538.fg)('fps_github_auth_banner_promo');
};
const $d1337898ab272d64$export$e4fdf56860b85064 = ()=>{
    return (0, $c6GJD.default).getExperimentValue('unified_search_right_rail_enhancements', 'cohort', 'control');
};
const $d1337898ab272d64$export$faafa351c854e058 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $c6GJD.default).getExperimentValue('rovo_search_settings_modal_enabled', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    });
const $d1337898ab272d64$export$97f8cc609584332 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $c6GJD.default).getExperimentValue('rovo_fps_show_slack_top_reaction_in_search_ab', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) !== 'control';
const $d1337898ab272d64$export$5526c331b5a2a0a4 = (options = {
    fireExperimentExposure: false
})=>{
    return (0, $c6GJD.default).getExperimentValue('quick_find_zero_query_3p_recs_experiment', 'isEnabled', false, options) === true;
};
/**
 * Default `featureServiceModel` value used by the recommendations backend
 * when no override is sent (control behaviour). Kept private to this module
 * since it is only ever passed as the default to `getExperimentValue` below.
 */ const $d1337898ab272d64$var$QUICK_FIND_RECS_DEFAULT_FEATURE_SERVICE_MODEL = 'quickfind_user_recs';
const $d1337898ab272d64$export$215e8e0e5adc6c3d = 'quickfind_user_recs_challenger_1';
const $d1337898ab272d64$export$a3c56d33595878d0 = (thirdPartyConfigs)=>{
    if (!thirdPartyConfigs) return false;
    const isAuthorised = (productKey)=>{
        const config = thirdPartyConfigs[productKey];
        if (!config) return false;
        if (config.userNeedsOAuth === false) return true;
        return config.datasources?.some((ds)=>ds?.userNeedsOAuth === false) ?? false;
    };
    return isAuthorised((0, $78z3f.ProductKeys3P).GoogleDrive) || isAuthorised((0, $78z3f.ProductKeys3P).Sharepoint);
};
const $d1337898ab272d64$export$153c8024578d07c3 = (thirdPartyConfigs, options = {
    fireExperimentExposure: false
})=>{
    if (!$d1337898ab272d64$export$a3c56d33595878d0(thirdPartyConfigs)) return false;
    const value = (0, $c6GJD.default).getExperimentValue('quick_find_recs_calibrated_3p_interleaver_exp', 'featureServiceModel', $d1337898ab272d64$var$QUICK_FIND_RECS_DEFAULT_FEATURE_SERVICE_MODEL, options);
    return value === $d1337898ab272d64$export$215e8e0e5adc6c3d;
};
const $d1337898ab272d64$export$6d6007cc7a6767d0 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_github_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$ba9c92ff563d2704 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_github_issues_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $d1337898ab272d64$export$1c4aca11d3a542d8 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $c6GJD.default).getExperimentValue('rovo_search_use_sl_clicked_only_in_recents', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
/**
 * Cohorts for QF GitHub tip banner experiment.
 *
 * - `control`            : banner is not rendered at all.
 * - `test-with-gnin`     : banner triggers on EITHER a GitHub keyword OR a
 *                         Jira GNIN-routing intent (typed JQL / work-item
 *                         key). Matches the experiment doc's "Test 1".
 * - `test-keyword-only`  : banner triggers on a GitHub keyword ONLY \u2014 the
 *                         Jira GNIN intent path is skipped. Matches the
 *                         experiment doc's "Test 2", Jira-specific.
 */ const $d1337898ab272d64$var$QF_GITHUB_TIP_BANNER_COHORTS = [
    'control',
    'test-with-gnin',
    'test-keyword-only'
];
const $d1337898ab272d64$export$839b881580a7010a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const value = (0, $c6GJD.default).getExperimentValue('rovo_qf_github_tip_banner', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    return $d1337898ab272d64$var$QF_GITHUB_TIP_BANNER_COHORTS.includes(value) ? value : 'control';
};
const $d1337898ab272d64$var$FULLPAGE_SEARCH_SUMMARIZE_BUTTON_REVAMP_TREATMENTS = [
    'control',
    'visibility',
    'border'
];
const $d1337898ab272d64$export$b67def2b3de3898b = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const treatment = (0, $c6GJD.default).getExperimentValue('fullpage_search_summarize_button_revamp', 'fullpage_search_summarize_button_revamp_treatment', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$FULLPAGE_SEARCH_SUMMARIZE_BUTTON_REVAMP_TREATMENTS.includes(treatment)) return treatment;
    return 'control';
};
const $d1337898ab272d64$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS = [
    'control',
    'auto_open_chat_modal',
    'on_demand_sain_banner',
    'inline_chat_input_in_results',
    'floating_chat_input'
];
const $d1337898ab272d64$export$e611075348720a7f = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('search_page_proactive_ai_multi_variant', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $d1337898ab272d64$var$JIRA_NAVIGATION_TO_GNIN_COHORTS = [
    'control',
    'work-item-icon',
    'header-link'
];
const $d1337898ab272d64$export$b68b3a4558aaedca = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $c6GJD.default).getExperimentValue('rovo_jira_navigation_to_gnin', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($d1337898ab272d64$var$JIRA_NAVIGATION_TO_GNIN_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
module.exports["triggerExposureForWeakLinkExp"] = $d1337898ab272d64$export$de65f9bad07950f2;
module.exports["serveWeakLinkExpWithoutExposure"] = $d1337898ab272d64$export$6c232948b0f89805;
module.exports["serveConvoStartersSameLine"] = $d1337898ab272d64$export$43910e1172480373;
module.exports["removeFedSlackFromAllProductSearch"] = $d1337898ab272d64$export$9f3b4e44245ab299;
module.exports["serveNounResultCounts"] = $d1337898ab272d64$export$b8eda33c6a73a867;
module.exports["serveWebPagesInTypeFilter"] = $d1337898ab272d64$export$6cc04d45455a2e52;
module.exports["serveJiraRecentsExcludeConfluenceWithoutExposure"] = $d1337898ab272d64$export$1b405ed1dcef1833;
module.exports["serveQFFilterSuggestionExperiment"] = $d1337898ab272d64$export$dbfae5c8d94a4c99;
module.exports["serveRightRailRecommendationsImprovementsWithExposure"] = $d1337898ab272d64$export$df1791a16917f9c3;
module.exports["serveQF3PBannerExperiment"] = $d1337898ab272d64$export$a254d1715475fc25;
module.exports["serveQF3PBannerExperimentWithoutExposure"] = $d1337898ab272d64$export$6308fede6bfa9216;
module.exports["serveConfluenceSpaceIconUpdate"] = $d1337898ab272d64$export$a28677150905172f;
module.exports["serve3PClickIngestionExperiment"] = $d1337898ab272d64$export$f980294cad954499;
module.exports["serveQuickFind3PBoostingExperiment"] = $d1337898ab272d64$export$32815557e5d06f0a;
module.exports["getMultiSiteSearchInRovo"] = $d1337898ab272d64$export$9e14285db0210414;
module.exports["serveOneClick3PConnectExperiment"] = $d1337898ab272d64$export$45bf6049ec3ec516;
module.exports["getUnifiedSearch3PConnectImprovementsCohort"] = $d1337898ab272d64$export$28f6b85de12145ce;
module.exports["isInUnifiedSearch3PConnectImprovementsTestCohort"] = $d1337898ab272d64$export$f22ea87ae194d314;
module.exports["serveImproveBannerTargetingExperiment"] = $d1337898ab272d64$export$647c2f5a2b1ce3a5;
module.exports["serveInline3PQuerySuggestionsPhase1"] = $d1337898ab272d64$export$1a051b8e8c16594f;
module.exports["serveFPSGitHubSocialProofBannerExperiment"] = $d1337898ab272d64$export$d776328c2da05809;
module.exports["serveFPSGitHubAuthBannerPromo"] = $d1337898ab272d64$export$380be6dfb8653da1;
module.exports["getUnifiedSearchRightRailEnhancementsExpValue"] = $d1337898ab272d64$export$e4fdf56860b85064;
module.exports["serveSearchSettingsModalExperiment"] = $d1337898ab272d64$export$faafa351c854e058;
module.exports["serveSlackTopReactionInSearchExperiment"] = $d1337898ab272d64$export$97f8cc609584332;
module.exports["serveQFZeroQuery3PRecsExperiment"] = $d1337898ab272d64$export$5526c331b5a2a0a4;
module.exports["QUICK_FIND_RECS_CHALLENGER_FEATURE_SERVICE_MODEL"] = $d1337898ab272d64$export$215e8e0e5adc6c3d;
module.exports["serveQuickFindRecommendationChallenger"] = $d1337898ab272d64$export$153c8024578d07c3;
module.exports["serveGithubRecentsExperiment"] = $d1337898ab272d64$export$6d6007cc7a6767d0;
module.exports["serveGithubWorkItemsRecentsExperiment"] = $d1337898ab272d64$export$ba9c92ff563d2704;
module.exports["serveSlClickedOnlyInRecentsExperiment"] = $d1337898ab272d64$export$1c4aca11d3a542d8;
module.exports["serveQfGithubTipBannerExperiment"] = $d1337898ab272d64$export$839b881580a7010a;
module.exports["serveFullpageSearchSummarizeButtonRevamp"] = $d1337898ab272d64$export$b67def2b3de3898b;
module.exports["getSearchPageProactiveAiMultiVariantCohort"] = $d1337898ab272d64$export$e611075348720a7f;
module.exports["serveJiraNavigationToGNIN"] = $d1337898ab272d64$export$b68b3a4558aaedca;

});

parcelRegister("6Gsan", function(module, exports) {
const $af14923fe5fc3bcc$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension'
};
module.exports["PrimaryProductKeys"] = $af14923fe5fc3bcc$export$15d12effc8830544;

});

parcelRegister("9d9t8", function(module, exports) {
// The canonical `ThirdPartyConfig` interface lives in
// `@atlassian/rovo-connectors-config`. It is consumed here to build the derived
// `ThirdPartyConfigsWithAPIResponse` type below.

var $eakyO = parcelRequire("eakyO");

const $320daaf61e2ab33a$export$e88fb694deeca21a = 'smartlinks-connector';
const $320daaf61e2ab33a$export$83921c8e433ffcd9 = 'lite-connector-';
const $320daaf61e2ab33a$export$7ad7a95070d8bb93 = (0, $eakyO.ConnectorSources).Federated;
const $320daaf61e2ab33a$export$e3a0662f044cd99b = (0, $eakyO.ConnectorSources).Lite;
const $320daaf61e2ab33a$export$c14e5e3fa6d8b46 = (0, $eakyO.ConnectorSources).Smartlinks;
const $320daaf61e2ab33a$export$aa06c0b5cc41ad9a = (0, $eakyO.ConnectorSources).Full;
const $320daaf61e2ab33a$export$37e0ed5b7fa94503 = (0, $eakyO.ConnectorSources).Backfill;
const $320daaf61e2ab33a$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $eakyO.ConnectorSources)).includes(value);
};
const $320daaf61e2ab33a$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $320daaf61e2ab33a$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($320daaf61e2ab33a$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $320daaf61e2ab33a$var$forgeConnectorIconsRegistry = new Map();
const $320daaf61e2ab33a$export$4e96e986802512bd = (productKey, icon)=>{
    $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $320daaf61e2ab33a$export$2f2bd8960b497856 = (productKey)=>{
    return $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.get(productKey);
};
const $320daaf61e2ab33a$export$2768da79a2599ca3 = ()=>{
    $320daaf61e2ab33a$var$forgeConnectorIconsRegistry.clear();
};
module.exports["SMARTLINKS_RESOURCE_TYPE_PREFIX"] = $320daaf61e2ab33a$export$e88fb694deeca21a;
module.exports["LITE_CONNECTOR_SOURCE_PREFIX"] = $320daaf61e2ab33a$export$83921c8e433ffcd9;
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $320daaf61e2ab33a$export$aa06c0b5cc41ad9a;
module.exports["isConnectorSource"] = $320daaf61e2ab33a$export$af092ad5a950adea;
module.exports["isForgeConnectorProductKey"] = $320daaf61e2ab33a$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $320daaf61e2ab33a$export$4e96e986802512bd;
module.exports["getForgeConnectorIcon"] = $320daaf61e2ab33a$export$2f2bd8960b497856;

});

parcelRegister("eakyO", function(module, exports) {
const $b8445082174fc78f$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $b8445082174fc78f$export$499e9a6668a55181;

});

parcelRegister("b4tvS", function(module, exports) {
/**
 * Product key constants, types, and lightweight helpers.
 * No icons, no 3P configs, no React components.
 */ 
var $dh538 = parcelRequire("dh538");


var $20IWy = parcelRequire("20IWy");


var $78z3f = parcelRequire("78z3f");


var $hdfeV = parcelRequire("hdfeV");


const $6f142b1a5d666130$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    // Can't add these until they're ready as we use this type to enforce that product configs are available for all products
    Talent: 'radar'
};
const $6f142b1a5d666130$export$252aae15ddb3591c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    Loom: 'loom',
    AtlasGoals: 'goals',
    AtlasProjects: 'projects',
    AtlasTeams: 'teams'
};
const $6f142b1a5d666130$export$ef2c0ffddaaaf76c = {
    ...$6f142b1a5d666130$var$ProductKeys1P,
    ...(0, $78z3f.ProductKeys3P)
};
const $6f142b1a5d666130$var$localAllProductKeys = Object.values($6f142b1a5d666130$export$ef2c0ffddaaaf76c);
const $6f142b1a5d666130$export$57043b2770b3924d = Object.values((0, $78z3f.ProductKeys3P));
const $6f142b1a5d666130$export$225f36a2f261b1e7 = Object.values($6f142b1a5d666130$var$ProductKeys1P);
const $6f142b1a5d666130$export$297680dde4e8aef1 = ()=>{
    if ((0, $dh538.fg)('rovo_fps_use_rovo_config')) return 0, $20IWy.allProductKeys;
    return $6f142b1a5d666130$var$localAllProductKeys;
};
const $6f142b1a5d666130$export$73be91b73ebbdb05 = $6f142b1a5d666130$var$localAllProductKeys;
const $6f142b1a5d666130$export$65f9ab1ba49d5e68 = (key)=>$6f142b1a5d666130$export$225f36a2f261b1e7.includes(key);
const $6f142b1a5d666130$export$ae4856d6227d0649 = (key)=>$6f142b1a5d666130$export$57043b2770b3924d.includes(key);
const $6f142b1a5d666130$export$2a41a819c1db85b1 = (key)=>{
    if (!key) return false;
    // Check hardcoded keys first
    if ($6f142b1a5d666130$export$297680dde4e8aef1().includes(key)) return true;
    // Treat any "forge-connector-*" string as valid ProductKeys to support
    // dynamically provisioned Forge connectors without updating this constant list.
    // This means isProductKey is *looser* than "is configured in ProductKeys".
    return key.startsWith('forge-connector-');
};
const $6f142b1a5d666130$export$ba4f56e768ae6f1e = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira
];
const $6f142b1a5d666130$export$64c23f2d9ef43822 = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    ...(0, $hdfeV.ProductsOrder3P)
];
const $6f142b1a5d666130$export$1d911f164123ed26 = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Github
];
const $6f142b1a5d666130$export$41ecd101a1ccdccc = [
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Confluence,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Jira,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Atlas,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Trello,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Bitbucket,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Compass,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Focus,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Talent,
    $6f142b1a5d666130$export$ef2c0ffddaaaf76c.Assets,
    ...(0, $hdfeV.NewProductsOrder3P)
];
module.exports["ProductKeys1PForAnalytics"] = $6f142b1a5d666130$export$252aae15ddb3591c;
module.exports["ProductKeys"] = $6f142b1a5d666130$export$ef2c0ffddaaaf76c;
module.exports["all3pProductKeys"] = $6f142b1a5d666130$export$57043b2770b3924d;
module.exports["all1pProductKeys"] = $6f142b1a5d666130$export$225f36a2f261b1e7;
module.exports["getAllProductKeys"] = $6f142b1a5d666130$export$297680dde4e8aef1;
module.exports["allProductKeys"] = $6f142b1a5d666130$export$73be91b73ebbdb05;
module.exports["is1pProductKey"] = $6f142b1a5d666130$export$65f9ab1ba49d5e68;
module.exports["is3pProductKey"] = $6f142b1a5d666130$export$ae4856d6227d0649;
module.exports["isProductKey"] = $6f142b1a5d666130$export$2a41a819c1db85b1;
module.exports["productsSupportingEmptyQuery"] = $6f142b1a5d666130$export$ba4f56e768ae6f1e;
module.exports["PRODUCTS_ORDER"] = $6f142b1a5d666130$export$64c23f2d9ef43822;
module.exports["GITHUB_PRODUCT_KEYS"] = $6f142b1a5d666130$export$1d911f164123ed26;
module.exports["PRODUCTS_ORDER_WITH_3P_BY_POPULARITY"] = $6f142b1a5d666130$export$41ecd101a1ccdccc;

});

parcelRegister("hdfeV", function(module, exports) {
/**
 * Pure 3P product key constants extracted for SSR bundle isolation.
 * No icon or config imports - just string mappings.
 *
 * This is the SOURCE OF TRUTH for ProductKeys3P.
 * 3p-product-configs/index.tsx and products.tsx re-export from here.
 */ 
var $78z3f = parcelRequire("78z3f");

const $2db55438f96b7ddd$export$cc64d659abc3d135 = [
    // Loom is actually a 1P so goes to the top
    (0, $78z3f.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $78z3f.ProductKeys3P).GoogleDrive,
    (0, $78z3f.ProductKeys3P).Sharepoint,
    (0, $78z3f.ProductKeys3P).OneDrive,
    (0, $78z3f.ProductKeys3P).Dropbox,
    (0, $78z3f.ProductKeys3P).Slack,
    (0, $78z3f.ProductKeys3P).Teams,
    (0, $78z3f.ProductKeys3P).Github,
    (0, $78z3f.ProductKeys3P).Figma,
    (0, $78z3f.ProductKeys3P).GoogleCalendar,
    (0, $78z3f.ProductKeys3P).Gmail,
    (0, $78z3f.ProductKeys3P).OutlookCalendar,
    (0, $78z3f.ProductKeys3P).OutlookMail,
    (0, $78z3f.ProductKeys3P).Airtable,
    (0, $78z3f.ProductKeys3P).Smartsheet,
    (0, $78z3f.ProductKeys3P).Asana,
    (0, $78z3f.ProductKeys3P).Zendesk,
    (0, $78z3f.ProductKeys3P).Miro,
    (0, $78z3f.ProductKeys3P).Docusign,
    (0, $78z3f.ProductKeys3P).Lucid,
    (0, $78z3f.ProductKeys3P).Monday,
    (0, $78z3f.ProductKeys3P).AzureDevops,
    (0, $78z3f.ProductKeys3P).Gitlab,
    (0, $78z3f.ProductKeys3P).ConfluenceDC,
    (0, $78z3f.ProductKeys3P).Canva,
    (0, $78z3f.ProductKeys3P).Box,
    (0, $78z3f.ProductKeys3P).Zeplin,
    (0, $78z3f.ProductKeys3P).ServiceNow,
    (0, $78z3f.ProductKeys3P).Freshservice,
    (0, $78z3f.ProductKeys3P).PowerBI,
    (0, $78z3f.ProductKeys3P).ClickUp,
    (0, $78z3f.ProductKeys3P).Amplitude,
    (0, $78z3f.ProductKeys3P).Stripe,
    (0, $78z3f.ProductKeys3P).AdobeXD,
    (0, $78z3f.ProductKeys3P).Aha,
    (0, $78z3f.ProductKeys3P).AdobeSign,
    (0, $78z3f.ProductKeys3P).Mural,
    (0, $78z3f.ProductKeys3P).Webex,
    (0, $78z3f.ProductKeys3P).PagerDuty,
    (0, $78z3f.ProductKeys3P).Pipedrive,
    (0, $78z3f.ProductKeys3P).Dovetail,
    (0, $78z3f.ProductKeys3P).LaunchDarkly,
    (0, $78z3f.ProductKeys3P).Salesforce,
    (0, $78z3f.ProductKeys3P).Sentry,
    (0, $78z3f.ProductKeys3P).Gitbook,
    (0, $78z3f.ProductKeys3P).AWSS3,
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
    (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
    (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
    (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
    (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
    (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
    (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
    // New 3P? Add it here
    (0, $78z3f.ProductKeys3P).Databricks,
    (0, $78z3f.ProductKeys3P).Notion,
    (0, $78z3f.ProductKeys3P).Todoist,
    (0, $78z3f.ProductKeys3P).Hubspot,
    (0, $78z3f.ProductKeys3P).JiraDC,
    (0, $78z3f.ProductKeys3P).JsmDC,
    // Always last
    (0, $78z3f.ProductKeys3P).AtlassianWebCrawler
];
// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const $2db55438f96b7ddd$export$915acbd1d0c0550d = [
    // Loom is actually a 1P so goes to the top
    (0, $78z3f.ProductKeys3P).Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    (0, $78z3f.ProductKeys3P).GoogleDrive,
    (0, $78z3f.ProductKeys3P).Sharepoint,
    (0, $78z3f.ProductKeys3P).Slack,
    (0, $78z3f.ProductKeys3P).Teams,
    (0, $78z3f.ProductKeys3P).Figma,
    (0, $78z3f.ProductKeys3P).Miro,
    (0, $78z3f.ProductKeys3P).Salesforce,
    (0, $78z3f.ProductKeys3P).Github,
    (0, $78z3f.ProductKeys3P).Gmail,
    (0, $78z3f.ProductKeys3P).Gitlab,
    (0, $78z3f.ProductKeys3P).Lucid,
    (0, $78z3f.ProductKeys3P).Asana,
    (0, $78z3f.ProductKeys3P).AzureDevops,
    (0, $78z3f.ProductKeys3P).GoogleCalendar,
    (0, $78z3f.ProductKeys3P).OneDrive,
    (0, $78z3f.ProductKeys3P).Dropbox,
    (0, $78z3f.ProductKeys3P).OutlookCalendar,
    (0, $78z3f.ProductKeys3P).OutlookMail,
    (0, $78z3f.ProductKeys3P).Airtable,
    (0, $78z3f.ProductKeys3P).Smartsheet,
    (0, $78z3f.ProductKeys3P).Zendesk,
    (0, $78z3f.ProductKeys3P).Docusign,
    (0, $78z3f.ProductKeys3P).Databricks,
    (0, $78z3f.ProductKeys3P).Monday,
    (0, $78z3f.ProductKeys3P).ConfluenceDC,
    (0, $78z3f.ProductKeys3P).Canva,
    (0, $78z3f.ProductKeys3P).Box,
    (0, $78z3f.ProductKeys3P).Zeplin,
    (0, $78z3f.ProductKeys3P).ServiceNow,
    (0, $78z3f.ProductKeys3P).Freshservice,
    (0, $78z3f.ProductKeys3P).PowerBI,
    (0, $78z3f.ProductKeys3P).ClickUp,
    (0, $78z3f.ProductKeys3P).Amplitude,
    (0, $78z3f.ProductKeys3P).Stripe,
    (0, $78z3f.ProductKeys3P).AdobeXD,
    (0, $78z3f.ProductKeys3P).Aha,
    (0, $78z3f.ProductKeys3P).AdobeSign,
    (0, $78z3f.ProductKeys3P).Mural,
    (0, $78z3f.ProductKeys3P).Webex,
    (0, $78z3f.ProductKeys3P).PagerDuty,
    (0, $78z3f.ProductKeys3P).Pipedrive,
    (0, $78z3f.ProductKeys3P).Dovetail,
    (0, $78z3f.ProductKeys3P).LaunchDarkly,
    (0, $78z3f.ProductKeys3P).Sentry,
    (0, $78z3f.ProductKeys3P).Gitbook,
    (0, $78z3f.ProductKeys3P).AWSS3,
    (0, $78z3f.ProductKeys3P).Notion,
    (0, $78z3f.ProductKeys3P).Todoist,
    (0, $78z3f.ProductKeys3P).Hubspot,
    (0, $78z3f.ProductKeys3P).JiraDC,
    (0, $78z3f.ProductKeys3P).JsmDC,
    // New 3P? Add it here
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
    (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
    (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
    (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
    (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
    (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
    (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
    (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
    (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
    (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
    (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
    (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
    (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
    (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
    (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
    (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
    (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
    (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
    (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
    (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
    // Always last
    (0, $78z3f.ProductKeys3P).AtlassianWebCrawler
];
const $2db55438f96b7ddd$export$c36c249aaac5cad0 = {
    assignee: [
        (0, $78z3f.ProductKeys3P).JiraDC,
        (0, $78z3f.ProductKeys3P).JsmDC
    ],
    campaignStatus: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    caseStatus: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    closeDate: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    // TODO: when cleaning up `rovo_fps_enable_gdrive_content_filter` / `rovo_fps_enable_sharepoint_content_filter`, add Google / Sharepoint here.
    content: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC
    ],
    // TODO: when cleaning up `rovo_fps_show_github_created_by_filter`, add Github + ForgePioGithubDev/Prod here.
    createdBy: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    label: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC
    ],
    lastUpdated: [
        (0, $78z3f.ProductKeys3P).Airtable,
        (0, $78z3f.ProductKeys3P).Asana,
        (0, $78z3f.ProductKeys3P).AzureDevops,
        (0, $78z3f.ProductKeys3P).Box,
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        (0, $78z3f.ProductKeys3P).Databricks,
        (0, $78z3f.ProductKeys3P).Docusign,
        (0, $78z3f.ProductKeys3P).Dropbox,
        (0, $78z3f.ProductKeys3P).Figma,
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
        (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
        (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
        (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
        (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
        (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
        (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
        (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
        (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
        (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
        (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
        (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
        (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
        (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
        (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).Gmail,
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).JiraDC,
        (0, $78z3f.ProductKeys3P).JsmDC,
        (0, $78z3f.ProductKeys3P).Loom,
        (0, $78z3f.ProductKeys3P).Lucid,
        (0, $78z3f.ProductKeys3P).Miro,
        (0, $78z3f.ProductKeys3P).Notion,
        (0, $78z3f.ProductKeys3P).OneDrive,
        (0, $78z3f.ProductKeys3P).OutlookMail,
        (0, $78z3f.ProductKeys3P).Salesforce,
        (0, $78z3f.ProductKeys3P).ServiceNow,
        (0, $78z3f.ProductKeys3P).Sharepoint,
        (0, $78z3f.ProductKeys3P).Slack,
        (0, $78z3f.ProductKeys3P).Smartsheet,
        (0, $78z3f.ProductKeys3P).Teams,
        (0, $78z3f.ProductKeys3P).Zendesk
    ],
    lastUpdatedBy: [
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    opportunityStatus: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    onlyTitleMatch: [
        (0, $78z3f.ProductKeys3P).Airtable,
        (0, $78z3f.ProductKeys3P).Asana,
        (0, $78z3f.ProductKeys3P).Box,
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        (0, $78z3f.ProductKeys3P).Databricks,
        (0, $78z3f.ProductKeys3P).Docusign,
        (0, $78z3f.ProductKeys3P).Dropbox,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        (0, $78z3f.ProductKeys3P).Hubspot,
        (0, $78z3f.ProductKeys3P).Miro,
        (0, $78z3f.ProductKeys3P).Notion,
        (0, $78z3f.ProductKeys3P).OneDrive,
        (0, $78z3f.ProductKeys3P).OutlookMail,
        (0, $78z3f.ProductKeys3P).Salesforce,
        (0, $78z3f.ProductKeys3P).ServiceNow,
        (0, $78z3f.ProductKeys3P).Sharepoint,
        (0, $78z3f.ProductKeys3P).Smartsheet,
        (0, $78z3f.ProductKeys3P).Zendesk
    ],
    owner: [
        (0, $78z3f.ProductKeys3P).Salesforce
    ],
    project: [
        (0, $78z3f.ProductKeys3P).JiraDC,
        (0, $78z3f.ProductKeys3P).JsmDC
    ],
    pullRequestStatus: [
        (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
        (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
        (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
        (0, $78z3f.ProductKeys3P).Github,
        (0, $78z3f.ProductKeys3P).Gitlab
    ],
    // TODO: when cleaning up `rovo_fps_show_repository_filter`, add Github + ForgePioGithubDev/Prod here.
    repository: [],
    slackChannel: [
        (0, $78z3f.ProductKeys3P).Slack
    ],
    // TODO: when cleaning up `rovo_fps_enable_gdrive_space_filter` / `rovo_fps_enable_sharepoint_space_filter`, add Google / Sharepoint here.
    space: [
        (0, $78z3f.ProductKeys3P).ConfluenceDC
    ],
    hasAttachment: [
        (0, $78z3f.ProductKeys3P).Teams
    ],
    // workspaceName is always in ThirdPartyConfigs.filters for Teams (gate controls filterIdOrdering only)
    workspaceName: [
        (0, $78z3f.ProductKeys3P).Teams
    ]
};
module.exports["ProductsOrder3P"] = $2db55438f96b7ddd$export$cc64d659abc3d135;
module.exports["NewProductsOrder3P"] = $2db55438f96b7ddd$export$915acbd1d0c0550d;
module.exports["thirdPartyFilterProducts"] = $2db55438f96b7ddd$export$c36c249aaac5cad0;

});

parcelRegister("dZJhp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1662I = parcelRequire("1662I");


var $3Klnc = parcelRequire("3Klnc");


var $5G9KX = parcelRequire("5G9KX");

const $7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY = 'quick_find_connect_apps_cooldown';
const $7d046d1f45bfe672$var$MAX_ANIMATIONS_PER_WEEK = 10;
const $7d046d1f45bfe672$var$DISMISSED_VALUE = 'dismissed';
const $7d046d1f45bfe672$var$getCurrentWeekKey = ()=>{
    const now = new Date();
    // ISO week-year + ISO week so we don't get an off-by-one across a year boundary
    // (e.g. Jan 1 can fall in the previous year's last ISO week).
    return `${(0, $3Klnc.default)(now)}_w${(0, $1662I.default)(now)}`;
};
const $7d046d1f45bfe672$var$readStore = ()=>{
    const raw = (0, $5G9KX.getLocalStorageItemAsString)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY);
    if (!raw) return null;
    try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && 'count' in parsed && 'weekKey' in parsed && typeof parsed.count === 'number' && typeof parsed.weekKey === 'string') return parsed;
        return null;
    } catch  {
        // JSON parse error — degrade gracefully.
        return null;
    }
};
const $7d046d1f45bfe672$var$isDismissed = ()=>{
    return (0, $5G9KX.getLocalStorageItemAsString)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY) === $7d046d1f45bfe672$var$DISMISSED_VALUE;
};
const $7d046d1f45bfe672$var$writeStore = (store)=>{
    try {
        (0, $5G9KX.setLocalStorageItem)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY, JSON.stringify(store));
    } catch  {
    // Private browsing / storage full / quota exceeded — degrade gracefully
    // (the animation plays anyway; we just lose the count for this attempt).
    }
};
const $7d046d1f45bfe672$export$92cbac270a4be2e0 = (maxPerWeek = $7d046d1f45bfe672$var$MAX_ANIMATIONS_PER_WEEK)=>{
    const canAnimate = (0, $42omo.useCallback)(()=>{
        if ($7d046d1f45bfe672$var$isDismissed()) return false;
        const weekKey = $7d046d1f45bfe672$var$getCurrentWeekKey();
        const stored = $7d046d1f45bfe672$var$readStore();
        if (stored?.weekKey === weekKey && stored.count >= maxPerWeek) return false;
        return true;
    }, [
        maxPerWeek
    ]);
    const recordAnimation = (0, $42omo.useCallback)(()=>{
        const weekKey = $7d046d1f45bfe672$var$getCurrentWeekKey();
        const stored = $7d046d1f45bfe672$var$readStore();
        const count = stored?.weekKey === weekKey ? stored.count + 1 : 1;
        $7d046d1f45bfe672$var$writeStore({
            weekKey: weekKey,
            count: count
        });
    }, []);
    const dismissPermanently = (0, $42omo.useCallback)(()=>{
        try {
            (0, $5G9KX.setLocalStorageItem)($7d046d1f45bfe672$var$COOLDOWN_STORAGE_KEY, $7d046d1f45bfe672$var$DISMISSED_VALUE);
        } catch  {
        // degrade gracefully
        }
    }, []);
    return {
        canAnimate: canAnimate,
        recordAnimation: recordAnimation,
        dismissPermanently: dismissPermanently
    };
};
module.exports["useConnectAppsCooldown"] = $7d046d1f45bfe672$export$92cbac270a4be2e0;

});


//# sourceMappingURL=PageLayout.4ab33c93.js.map
